// Small brand-colored channel logos, shared across the Home and Integrations
// pages. Kept as inline SVG (not images) so they stay crisp at any size and
// need no extra network requests.
export default function ChannelLogo({ type, className = 'h-7 w-7' }) {
  if (type === 'whatsapp') {
    return (
      <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <circle cx="32" cy="32" r="28" fill="#25D366" />
        <path fill="#fff" d="M47.2 16.8A21.4 21.4 0 0 0 32 10.5c-11.9 0-21.5 9.6-21.5 21.5 0 3.8 1 7.4 2.9 10.6L10.2 53.5l11.2-3a21.4 21.4 0 0 0 10.6 2.8h.1c11.8 0 21.4-9.6 21.4-21.4 0-5.7-2.2-11.1-6.3-15.1zM32.1 49.5h-.1c-3.3 0-6.5-.9-9.3-2.5l-.7-.4-6.6 1.8 1.8-6.4-.4-.7a17.8 17.8 0 1 1 15.3 8.2zm9.8-13.4c-.5-.2-3-1.5-3.5-1.7-.5-.2-.8-.2-1.1.2-.3.5-1.3 1.7-1.6 2-.3.3-.6.4-1.1.1-.5-.2-2.1-.8-4-2.4-1.5-1.3-2.5-3-2.8-3.5-.3-.5 0-.8.2-1 .2-.2.5-.6.8-.9.3-.3.4-.5.6-.9.2-.4.1-.7-.1-1-.1-.2-1.1-2.7-1.5-3.7-.4-1-.8-.9-1.1-.9h-.9c-.3 0-.9.1-1.4.7-.5.5-1.9 1.8-1.9 4.4s1.9 5.1 2.2 5.5c.3.3 3.7 5.7 9 8 .1.1.2.1.3.1 1.2.5 2.1.9 2.8 1.1 1.3.4 2.5.3 3.4.2 1-.2 3-1.2 3.4-2.4.4-1.2.4-2.2.3-2.4-.1-.2-.4-.3-.9-.5z" />
      </svg>
    );
  }

  if (type === 'instagram') {
    return (
      <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <defs>
          <linearGradient id="ig-gradient" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0" stopColor="#FFDC80" />
            <stop offset=".28" stopColor="#F77737" />
            <stop offset=".55" stopColor="#E1306C" />
            <stop offset=".78" stopColor="#C13584" />
            <stop offset="1" stopColor="#833AB4" />
          </linearGradient>
        </defs>
        <rect x="6" y="6" width="52" height="52" rx="15" fill="url(#ig-gradient)" />
        <rect x="18" y="18" width="28" height="28" rx="8" fill="none" stroke="#fff" strokeWidth="4" />
        <circle cx="32" cy="32" r="7" fill="none" stroke="#fff" strokeWidth="4" />
        <circle cx="43" cy="21" r="2.8" fill="#fff" />
      </svg>
    );
  }

  if (type === 'teams') {
    return (
      <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <defs>
          <linearGradient id="teams-head" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#A6BCFF" />
            <stop offset="1" stopColor="#5B43D9" />
          </linearGradient>
          <linearGradient id="teams-body" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#8C7AFF" />
            <stop offset="1" stopColor="#5A35D6" />
          </linearGradient>
          <linearGradient id="teams-tile" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#6759E8" />
            <stop offset="1" stopColor="#3D2AB4" />
          </linearGradient>
        </defs>
        <circle cx="45" cy="15" r="8" fill="url(#teams-head)" />
        <path d="M37 25c0-5 4-9 9-9h2c5 0 9 4 9 9v16c0 4-3 7-7 7h-6c-4 0-7-3-7-7z" fill="url(#teams-body)" />
        <circle cx="25" cy="20" r="9" fill="url(#teams-head)" />
        <path d="M8 38c0-8 6-14 14-14h7c8 0 14 6 14 14v12c0 4-3 7-7 7H15c-4 0-7-3-7-7z" fill="#8CB5FF" />
        <rect x="10" y="29" width="28" height="28" rx="6" fill="url(#teams-tile)" />
        <path d="M15 36h18v5h-6v11h-6V41h-6z" fill="#fff" />
      </svg>
    );
  }

  if (type === 'slack') {
    return (
      <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <path fill="#36C5F0" d="M15 38a6 6 0 1 1 0-12h6v12h-6z" />
        <path fill="#2EB67D" d="M26 15a6 6 0 1 1 12 0v6H26v-6z" />
        <path fill="#ECB22E" d="M49 26a6 6 0 1 1 0 12h-6V26h6z" />
        <path fill="#E01E5A" d="M38 49a6 6 0 1 1-12 0v-6h12v6z" />
        <path fill="#36C5F0" d="M21 49a6 6 0 1 1 0-12h5v12h-5z" />
        <path fill="#2EB67D" d="M38 21a6 6 0 1 1-12 0v-5a6 6 0 1 1 12 0v5z" />
        <path fill="#ECB22E" d="M43 38a6 6 0 1 1 0-12h5a6 6 0 1 1 0 12h-5z" />
        <path fill="#E01E5A" d="M26 43a6 6 0 1 1 12 0v5a6 6 0 1 1-12 0v-5z" />
      </svg>
    );
  }

  // 'web' / default — generic web-widget chat bubble in brand teal.
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect x="7" y="7" width="50" height="42" rx="12" fill="#00918F" />
      <path d="M18 49l-2 9 12-9" fill="#00918F" />
      <circle cx="22" cy="28" r="3.5" fill="#fff" />
      <circle cx="32" cy="28" r="3.5" fill="#fff" />
      <circle cx="42" cy="28" r="3.5" fill="#fff" />
    </svg>
  );
}
